import { Tab, Tabs, Typography, Badge, Paper, makeStyles } from "@material-ui/core";
import React, { useState, useEffect, forwardRef } from "react"
import { useLocation } from 'react-router-dom';
import api from '../api';
import ListTabScreen from "./ListTabScreen";

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        width: "100%",
        backgroundColor: theme.palette.background.paper
    },
    tabsIndicator: {
        backgroundColor: "#2a9c6c"
    },
    tabRoot: {
        "&:hover": {
            color: "red",
            opacity: 1
        },
        "&$tabSelected": {
            color: "red",
            fontWeight: theme.typography.fontWeightMedium
        },
        "&:focus": {
            color: "red"
        }
    },
    tabSelected: {},
    fab: {
        '& > *': {
            margin: theme.spacing(1),
        },
        position: 'fixed',
        right: 25,
        top: 65
    },
    extendedIcon: {
        marginRight: theme.spacing(1),
    },
}))

function TabScreen() {
    
    let location = useLocation();
    const classes = useStyles()

    const [call, setCall] = useState(false);
    const [selectedTab, setSelectedTab] = useState(0);
    const [dataTab, setDataTab] = useState([]);
    const [dataContentTab, setDataContentTab] = useState([]);

    const handleChange = (event, index) => {
        changeSelectedTab(index);
    };

    const changeSelectedTab = (index) => {
        setSelectedTab(index);
        if(dataTab.length > 0){
            console.log('Facility id '+dataTab[index].facility_id)
            let tabId = dataTab[index].id;
            let facilityID = dataTab[index].facility_id;
            if(tabId != null){
                getListContentTab(tabId);
            }else{
                getListContentTabMissed(facilityID, false)
            }
        }
    }

    const getListTab = () => {
        api.create().getSubFacilityByFacilityID(location.state.id).then(response => {
            console.log(response);
            console.log('Get List Tab');
            let listTab = [];
            if (response.data) {
                var data = response.data;
                if (data.status === true) {
                    listTab = data.data
                    let totalSkip = 0
                    listTab.push({
                        name: 'List Antrian - Terlewat',
                        facility_id: location.state.id,
                        id: null,
                        total_queue: totalSkip
                    })
                }
                setDataTab(listTab)
                if(listTab.length > 0){
                    let tabId = listTab[0].id;
                    let facilityID = listTab[0].facility_id;
                    getListContentTab(tabId);
                    getListContentTabMissed(facilityID, true)
                }
            }
        })
    }

    const getListContentTab = (tabID) => {
        api.create().getListSubFacility(tabID).then(response => {
            console.log('GET DATA TAB '+tabID);
            console.log(response);
            let dataListContentTab = [];
            if(response.data){
                dataListContentTab = response.data.data.map((item, index)=>{
                    var model = {
                        "que_number": item.queue_number,
                        "booking_id": item.booking_id,
                        "patient_medical_record_no": item.patient_medical_record_no === null ? item.patient_medical_record_no_2 : item.patient_medical_record_no,
                        "patient_name": item.patient_name === null ? item.patient_name_2 : item.patient_name,
                        "patient_gender": item.patient_gender === null ? item.patient_gender_2 : item.patient_gender,
                        "payment_option_name": item.payment_option_name,
                        "processed_by": item.processed_by ? item.processed_by : '-',
                        "facility_counter_name": item.facility_counter_name ? item.facility_counter_name : '-',
                        "status": item.is_called === 1 && (item.queue_status_name === "New" || item.queue_status_name === "Menunggu") ? "Dipanggil" : item.is_called === 1 && (item.queue_status_name === "Process" || item.queue_status_name === "Dilayani") ? "Dilayani" : (item.queue_status_name === "Skip" || item.queue_status_name === "Dilewati") ? "Dilewati" : item.queue_status_name,
                        "is_called": item.is_called,
                        "facility_id": item.facility_id,
                        "facility_queue_id": item.facility_queue_id,
                        "sub_facility_id": item.sub_facility_id,
                        "sub_facility_queue_id": item.sub_facility_queue_id,
                        "facility_counter_id": item.facility_counter_id,
                        "queue_status_id": item.queue_status_id,
                    }
                    return model;
                });
                setDataContentTab(dataListContentTab);
            }
            setCall(!call); 
        })
    }

    const getListContentTabMissed = (id, updateBadge) => {
        api.create().getPemanggilanSubFacilitySkip(id).then(response => {
            console.log(response);
            let dataListContentTab = [];
            if(response.data){
                dataListContentTab = response.data.data.map((item, index)=>{
                    var model = {
                        "que_number": item.queue_number,
                        "booking_id": item.booking_id,
                        "patient_medical_record_no": item.patient_medical_record_no === null ? item.patient_medical_record_no_2 : item.patient_medical_record_no,
                        "patient_name": item.patient_name === null ? item.patient_name_2 : item.patient_name,
                        "patient_gender": item.patient_gender === null ? item.patient_gender_2 : item.patient_gender,
                        "payment_option_name": item.payment_option_name,
                        "processed_by": item.processed_by ? item.processed_by : '-',
                        "facility_counter_name": item.facility_counter_name ? item.facility_counter_name : '-',
                        "status": item.is_called === 1 && (item.queue_status_name === "New" || item.queue_status_name === "Menunggu") ? "Dipanggil" : item.is_called === 1 && (item.queue_status_name === "Process" || item.queue_status_name === "Dilayani") ? "Dilayani" : (item.queue_status_name === "Skip" || item.queue_status_name === "Dilewati") ? "Dilewati" : item.queue_status_name,
                        "is_called": item.is_called,
                        "facility_id": item.facility_id,
                        "facility_queue_id": item.facility_queue_id,
                        "sub_facility_id": item.sub_facility_id,
                        "sub_facility_queue_id": item.sub_facility_queue_id,
                        "facility_counter_id": item.facility_counter_id,
                        "queue_status_id": item.queue_status_id,
                    }
                    return model;
                });
            }
            //update total que tab miss
            if(updateBadge){
                dataTab.filter(function(obj){
                    if(obj.id == null){
                        obj.total_queue = dataListContentTab;
                    }
                })
                console.log('update tab = '+dataTab)
            }else{
                setDataContentTab(dataListContentTab);
                setCall(!call); 
            }
            
        })
    }

    useEffect(()=>{
        getListTab()
    }, [])

    
    // const forceUpdate = React.useReducer(bool => !bool)[1];
    
    return (
        <>
            <Paper style={{ boxShadow: 'none' }} >
                <Tabs
                    value={selectedTab}
                    onChange={handleChange}
                    aria-label="disabled tabs example"                    
                    indicatorColor="primary"
                    textColor="#2a9c6c"
                    style={{ outline: 'null' }}
                    classes={{ indicator: classes.tabsIndicator }}
                >
                    {dataTab.map((item, index)=>(
                        <Tab 
                            id={item.id} 
                            label={<Badge badgeContent={item.total_queue} color="primary">{item.name}</Badge>}
                            style={{ color: selectedTab === index ? '#2a9c6c' : 'black' }}/>
                    ))}

                </Tabs>
            </Paper>
            <ListTabScreen
                tabID={selectedTab}
                data={dataContentTab}
                loket={true}
                callback={call}
            />
        </>
    );
}

export default TabScreen;